import { Button } from "@/view/components/ui/button"
import { Dialog, DialogContent, DialogFooter } from "@/view/components/ui/dialog"
import { useToast } from "@/view/components/ui/use-toast";
import { useState } from "react";

interface AuthorizationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onAdvance: () => void;

  onVerifyAuthorization: () => Promise<boolean>;
}

export const AuthorizationModal = ({ isOpen, onOpenChange, title, description, onAdvance, onVerifyAuthorization }: AuthorizationModalProps) => {
  const { toast } = useToast()
  const [isLoadingVerify, setIsLoadingVerify] = useState(false)

  const handleVerify = async () => {
    try {
      setIsLoadingVerify(true)
      const isAuthorized = await onVerifyAuthorization()
      if (!isAuthorized) {
        toast({
          title: 'Erro ao verificar autorização',
          variant: 'destructive',
        })
      }
      setIsLoadingVerify(false)
    } catch (error) {
      console.error(error)
      setIsLoadingVerify(false)
    }
  }
  return (

    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        variant="bottomSheet"
        className="sm:max-w-sm sm:rounded-xl"
        showCloseButton={false}
      >
        <h2 className="text-center text-lg font-semibold text-black01 sm:text-xl">
          {title}
        </h2>
        <p className="text-center text-sm font-medium text-black01 sm:text-base">
          {description}
        </p>

        <DialogFooter className="flex flex-col sm:flex-col gap-2 justify-center sm:space-x-0">
          <Button
            disabled={isLoadingVerify}
            onClick={onAdvance}
            size="lg"
            className="w-full rounded-full bg-primary text-white"
          >
            Avançar
          </Button>
          <Button
            isLoading={isLoadingVerify}
            variant="outline"
            onClick={handleVerify}
            size="lg"
            className="w-full rounded-full bg-gray01 "
          >
            Já autorizei a consulta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

  )
}